import { Link, useLocation } from 'react-router-dom';

/**
 * A single nav tab (link variant). Renders an <a> with optional `active` class
 * when section.match(currentPath) returns true.
 *
 * For dropdown sections, use PlatformMenu / AvatarMenu — this component is for
 * plain link tabs only.
 */
export default function NavTab({ section }) {
    const location = useLocation();
    const isActive = section.match(location.pathname);
    const variantClass = section.variant ? `variant-${section.variant}` : '';
    const className = `nav-tab ${isActive ? 'active' : ''} ${variantClass}`.trim();

    return (
        <Link to={section.to} className={className}>
            {section.label}
        </Link>
    );
}
